import { ROOM_SIZE_NAMES } from 'Globals/Constants'

export const clamp = (num: number, min: number, max: number) =>
  Math.min(Math.max(num, min), max)

export const formatNumber = (number: number | string) => {
  return +number > 10_000
    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
    : number
}
export const roomSizeStringFormatter = (roomSize: string) =>
  roomSize
    .replace('Zi_', '')
    .replace('-', '–')
    .replace('.', ',')

export const roomSizeNumberToStringConverter = (size: number) =>
  roomSizeStringFormatter(ROOM_SIZE_NAMES[size])
